<template>
  <div ref="container" :class="classes" v-if="layout === 'logo'">
    <div class="image dublab-logo"></div>
  </div>
  <div ref="container" :class="classes" v-else-if="layout === 'on_air'">
    <p v-html="onAir"></p>
  </div>
  <div ref="container" :class="classes" v-else-if="layout === 'up_next'">
    <div class="flex"><p v-if="onAir" v-html="onAir"></p></div>
    <div class="flex"><p v-if="upNext" v-html="upNext"></p></div>
  </div>
  <div ref="container" :class="classes" v-else-if="layout === 'current_time'">
    <p>
      It’s<br />{{ date.dow }}<br />{{ date.date }}<br /><span
        >{{ date.time }} {{ date.timezone }}</span
      >
    </p>
  </div>
  <div ref="container" :class="classes" v-else-if="layout === 'text'">
    <p v-html="slide.text"></p>
  </div>
  <div ref="container" :class="classes" v-else-if="layout === 'sponsor_logos'">
    <div class="label">{{ slide.text }}</div>
    <div class="images">
      <div
        v-for="logo in slide.logos"
        class="image"
        :style="`background-image:url(${logo})`"
        :key="logo"
      ></div>
    </div>
  </div>
  <div ref="container" :class="classes" v-else-if="layout === 'sponsor_names'">
    <div class="label">{{ slide.text }}</div>
    <div class="flex"><p v-html="slide.names"></p></div>
  </div>
</template>

<script>
/**
 * Todo
 *
 * - [x] does on air exist?
 * - [x] does up next exist?
 * - [x] font sizing
 * - [x] styles
 * - [x] mobile
 * - [ ] if "is on air" check
 */
import dayjs from "dayjs";
import widont from "widont";
import fittext from "@/lib/fit-text.js";

export default {
  name: "HomeSlide",
  props: {
    slide: {
      default: {},
    },
  },
  data() {
    return {
      sizes: ["12.0rem", "9.0rem", "6.0rem", "3.6rem", "2.8rem", "2.0rem"],
      frame: {},
    };
  },
  computed: {
    layout() {
      return this.slide.acf_fc_layout;
    },
    classes() {
      return ["HomeSlide", "SlideLayout--" + this.slide.acf_fc_layout];
    },
    playing() {
      return this.$store.state.audio.playing;
    },
    onAir() {
      return this.formatShow(this.playing.on_air, "On Air");
    },
    upNext() {
      return this.formatShow(this.playing.up_next, "Up Next");
    },
    date() {
      return this.$store.state.date.local;
    },
  },
  methods: {
    formatUnixTime(timestamp) {
      if (!timestamp) return "";
      let time = dayjs(new Date(timestamp * 1000))
        .format("h:mm a")
        .replace("am", "a.m.")
        .replace("pm", "p.m.");
      return time;
    },
    formatShow(show, label) {
      if (show.combo && show.start && show.end) {
        const title = show.combo;
        let start = this.formatUnixTime(show.start);
        let end = this.formatUnixTime(show.end);
        return `${label}<br><span>${start}</span> <span>to ${end}</span><br>${widont(
          title
        )}`;
      } else return "";
    },
    format() {
      if (!this.$refs.container) return;
      const els = [...this.$refs.container.querySelectorAll("p")];
      let size_options =
        this.layout === "on_air" ? this.sizes.slice(1) : this.sizes.slice(0);
      const sizes = els.map((el) => fittext(el, size_options));

      // ensure font sizes in same slide are unified
      if (sizes.length > 1) {
        let sorted = sizes.sort((a, b) => b.index - a.index);
        let size = sorted[0].size;
        els.forEach((el) => (el.style.fontSize = size));
      }
    },
    safeFormat() {
      this.$nextTick(() => this.format());
      // timeout failsafe :)
      clearTimeout(this.frame.debounce);
      this.frame.debounce = setTimeout(() => this.format(), 50);
    },
    resize() {
      clearTimeout(this.frame.resize);
      this.frame.resize = setTimeout(() => this.format(), 100);
    },
  },
  mounted() {
    this.safeFormat();
    window.addEventListener("resize", this.resize.bind(this), false);
  },
  willDestroy() {
    clearTimeout(this.frame.resize);
    clearTimeout(this.frame.debounce);
    window.removeEventListener("resize", this.resize.bind(this), false);
  },
  updated() {
    this.safeFormat();
  },
};
</script>

<style scoped>
.HomeSlide {
  /*height: calc(100vh - var(--mb) - 2.5rem);*/
  height: 100%;
  width: 100%;
  padding: 8rem;
  overflow: hidden;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  color: #fff;
  text-shadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
  font-weight: bold;
  line-height: 1.1;
  text-align: center;
  user-select: none;
  /*word-break: break-word;*/
}

@media (max-width: 920px) {
  .HomeSlide {
    padding-left: 3rem;
    padding-right: 3rem;
    padding-bottom: 4rem;

    text-shadow: -1px 0 rgba(0, 0, 0, 0.5), 0 1px rgba(0, 0, 0, 0.5),
      1px 0 rgba(0, 0, 0, 0.5), 0 -1px rgba(0, 0, 0, 0.5);
  }
}

.image {
  width: 100%;
  max-width: 90rem;
  height: 100%;
  background-size: contain;
  background-position: center;
}

.flex {
  display: flex;
  align-content: center;
  justify-content: center;
  flex-direction: column;
}

.dublab-logo {
  background-image: url("~@/assets/images/stream_dublab-logo.svg");
}

@media (min-width: 920px) {
  .HomeSlide >>> span {
    display: inline-block;
    white-space: nowrap;
  }
}

/**
 * Layout: On Air
 */

.SlideLayout--on_air >>> span {
  /*display: inline-block;*/
}

/**
 * Layout: Up Next
 */

.SlideLayout--up_next {
  padding: 6rem;
}

.SlideLayout--up_next div {
  width: 100%;
  height: 50%;
  padding: 2rem;
  align-self: flex-end;
}

.SlideLayout--up_next div:last-child {
  align-self: flex-start;
}

.SlideLayout--up_next div:empty {
  display: none;
}

.SlideLayout--up_next >>> span {
  display: inline-block;
}

@media (min-width: 1000px) {
  .SlideLayout--up_next div {
    width: 50%;
  }
}

@media (max-width: 920px) {
  .SlideLayout--up_next {
    padding-left: 2rem;
    padding-right: 2rem;
    padding-bottom: 3rem;
    
  }

  .SlideLayout--up_next div {
    padding: 1rem;
  }
}

/**
 * Layout: Sponsors
 */

.SlideLayout--sponsor_logos .label,
.SlideLayout--sponsor_names .label {
  padding-bottom: 4rem;
  font: var(--large);
  font-weight: bold;
}

.SlideLayout--sponsor_names > *:last-child {
  flex: 1;
  width: 100%;
}

.SlideLayout--sponsor_names > *:last-child div {
  height: 100%;
  width: 100%;
}

.SlideLayout--sponsor_logos .images {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.SlideLayout--sponsor_logos .image {
  margin: 0 4rem;
}

@media (orientation: portrait) {
  .SlideLayout--sponsor_logos .images {
    flex-direction: column;
  }

  .SlideLayout--sponsor_logos .image {
    margin: 2rem 0;
  }
}
</style>
